import hamburger from './hamburger';

export default new function common($) {
  this.init = () => {
    this.addEvents();
    this.modifyDOM();
    hamburger();
  };

  this.modifyDOM = () => {
    $('.swiper-container').each(function() {
      const containerWidth = $(this).width();
      let slidesPerView = parseInt($(this).data('slides-per-view'), 10);
      let maxSlidesPerView;

      if (containerWidth <= 460) { // xxs
        maxSlidesPerView = 1;
      } else if (containerWidth <= 767) { // xs
        maxSlidesPerView = 2;
      } else if (containerWidth <= 991) { // sm
        maxSlidesPerView = 3;
      } else {
        maxSlidesPerView = 4;
      }

      if (slidesPerView > maxSlidesPerView) {
        slidesPerView = maxSlidesPerView;
      }

      const sw = new window.Swiper($(this), {
        // loop: true,
        nextButton: '[data-target="' + $(this).attr('id') +  '"].swiper-button-next',
        prevButton: '[data-target="' + $(this).attr('id') +  '"].swiper-button-prev',
        autoplay: false,
        slidesPerView
      });

      if ($(this).find('.swiper-slide').length <= slidesPerView) {
        sw.lockSwipes();
      }
    });
  };

  this.addEvents = () => {
    $('body').on('click', '.overlay', this.eventHandlers.closeModal).
              on('click', '.js-youtube', this.eventHandlers.openYoutubeModal).
              on('click', '.primary-nav__search-btn', this.eventHandlers.toggleSearchForm).
              on('change', '.js-category-switcher select', this.eventHandlers.submitForm);

    $(window).on('scroll', this.eventHandlers.onScroll);
  };

  this.eventHandlers = {
    openYoutubeModal() {
      $('.modal').addClass('active modal--youtube');
      const url = `https://www.youtube.com/embed/${$(this).data('youtube-id')}`;
      $('.modal').html(`<iframe src="${url}" frameborder="0" allowfullscreen></iframe>`);
      $('body').addClass('overlay-visible');
      return false;
    },

    closeModal() {
      $('.modal').empty();
      $('.modal').removeClass('active');
      $('body').removeClass('overlay-visible');
    },

    toggleSearchForm() {
      $('.primary-nav__right').toggleClass('search-mode');
      $('.primary-nav__search-form input').focus();
    },

    submitForm() {
      if ($(this).val() === '0') {
        window.location.href = $(this).parents('form').data('base-url');
        return false;
      }

      $(this).parents('form').submit();
    },

    onScroll() {
      const scrolled = $(window).scrollTop();

      if (scrolled >= 60) {
        $('html').addClass('has-scrolled');
      } else {
        $('html').removeClass('has-scrolled');
      }
    }
  };

  this.helpers = {

  };

  return this.init;
}(jQuery);
